export default __webpack_public_path__ + "static/media/dtmf-7.e362a35f.mp3";